const playerDescr = (audioDescr) => {
  const btnPlayDescr = document.getElementById('btn-play-descr');
  const svgPlayDescr = document.getElementById('svg-play-descr');
  const svgPauseDescr = document.getElementById('svg-pause-descr');
  const audioPlayerDescr = document.querySelector(".audio-player-descr");
  

  audioDescr.addEventListener(
    "loadeddata",
    () => {
      audioPlayerDescr.querySelector(".timebar-time-info .length").textContent = getTimeCodeFromNumDescr(
        audioDescr.duration
      );
      audioDescr.volume = .75;
    },
    false
  );

    //click on timeline to skip around
  const timelineDescr = audioPlayerDescr.querySelector(".timebar");
  timelineDescr.addEventListener("click", e => {
    const timelineWidthDescr = window.getComputedStyle(timelineDescr).width;
    const timeToSeekDescr = e.offsetX / parseInt(timelineWidthDescr) * audioDescr.duration;
    audioDescr.currentTime = timeToSeekDescr;
  }, false);

  //click volume slider to change volume
  const volumeSliderDescr = audioPlayerDescr.querySelector(".controls .volume-slider");
  volumeSliderDescr.addEventListener('click', e => {
    const sliderWidthDescr = window.getComputedStyle(volumeSliderDescr).width;
    const newVolumeDescr = e.offsetX / parseInt(sliderWidthDescr);
    audioDescr.volume = newVolumeDescr;
    audioPlayerDescr.querySelector(".controls .volume-percentage").style.width = newVolumeDescr * 100 + '%';
  }, false)

  //check audio percentage and update time accordingly
  setInterval(() => {
    const progressBarDescr = audioPlayerDescr.querySelector(".timebar-bar");
    const timebarCircleDescr = audioPlayerDescr.querySelector(".timebar-circle");
    progressBarDescr.style.width = audioDescr.currentTime / audioDescr.duration * 100 + "%";
    timebarCircleDescr.style.left = audioDescr.currentTime / audioDescr.duration * 100 + "%";
    audioPlayerDescr.querySelector(".timebar-time-info .current").textContent = getTimeCodeFromNumDescr(audioDescr.currentTime);

  }, 500);

  btnPlayDescr.addEventListener(
    "click",
    () => {
      if (audioDescr.paused) {
      
      
        svgPlayDescr.classList.add('display-none');
        svgPauseDescr.classList.remove('display-none');
        audioDescr.play();
      } else {
  
        svgPlayDescr.classList.remove('display-none');
        svgPauseDescr.classList.add('display-none');
        audioDescr.pause();
      }
    },
    false
  );

  const soundPlayerDescr = document.getElementById('sound-player-descr');
  soundPlayerDescr.addEventListener("click", () => {
    audioDescr.muted = !audioDescr.muted;
  
  });

  //turn 128 seconds into 2:08
  const getTimeCodeFromNumDescr = (num) => {
    let seconds = parseInt(num);
    let minutes = parseInt(seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt(minutes / 60);
    minutes -= hours * 60;

    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
    return `${String(hours).padStart(2, 0)}:${minutes}:${String(
      seconds % 60
    ).padStart(2, 0)}`;
  };

};

export default playerDescr;